import { create } from "zustand";
import { useAppServices } from "../../app/services";
import { getIsPrivateEdition } from "../../auth/PrivateEditionView";
import { AppHintID, getCustomerCenterAuthCallbackUrl, HELP_CENTER_EXTERNAL_URL, KnownArticle, navigateToHelpCenter } from "../HelpCommon";
import { createWithEqualityFn } from "zustand/traditional";
import { useTranslation } from "react-i18next";

interface HelpDrawerState {
    helpDrawerOpen: boolean;
    helpCenterUrl: string;
    setHelpDrawerOpen: (open: boolean) => void;
    setHelpCenterUrl: (url: string) => void;
}
create;

export const useHelpDrawerState = createWithEqualityFn<HelpDrawerState>((set) => ({
    helpDrawerOpen: false,
    helpCenterUrl: "",
    setHelpDrawerOpen: (open: boolean) =>
        set({
            helpDrawerOpen: open,
        }),
    setHelpCenterUrl: (url: string) =>
        set({
            helpCenterUrl: url,
        }),
}));

export const useOpenHelpArticle = () => {
    const { dialogService } = useAppServices();
    const helpDrawerState = useHelpDrawerState();
    const isPrivateEdition = getIsPrivateEdition();
    const { t } = useTranslation();

    return async (articleSlug: KnownArticle) => {
        if (isPrivateEdition) {
            const confirmed = await dialogService.addConfirmDialog({
                title: t("common:actions.openInBrowser"),
                message: `${HELP_CENTER_EXTERNAL_URL}/kb/articles/${articleSlug}`,
                autoConfirmationQuestionLine: false,
            });
            if (confirmed) {
                navigateToHelpCenter(articleSlug);
            }
        } else {
            const redirectString = `kb/articles/${articleSlug}?from=cmc`;
            helpDrawerState.setHelpCenterUrl(getCustomerCenterAuthCallbackUrl(redirectString));
            helpDrawerState.setHelpDrawerOpen(true);
        }
    };
};

export const useOpenHelpSearch = () => {
    const { dialogService } = useAppServices();
    const helpDrawerState = useHelpDrawerState();
    const isPrivateEdition = getIsPrivateEdition();
    const { t } = useTranslation();

    return async (searchTerm: AppHintID) => {
        if (isPrivateEdition) {
            const confirmed = await dialogService.addConfirmDialog({
                title: t("common:actions.openInBrowser"),
                message: `${HELP_CENTER_EXTERNAL_URL}/kb/search?q=${searchTerm}`,
                autoConfirmationQuestionLine: false,
            });
            if (confirmed) {
                navigateToHelpCenter(searchTerm);
            }
        } else {
            const redirectString = `kb/search?q=${searchTerm}&from=cmc`;
            helpDrawerState.setHelpCenterUrl(getCustomerCenterAuthCallbackUrl(redirectString));
            helpDrawerState.setHelpDrawerOpen(true);
        }
    };
};
